<template>
    <div class="info-box">
       <el-image :src="imageSrc" style="width:100px;height:100px;border-radius:10px;margin-right: 20px;"></el-image>
       <div style="flex:1">
           <div><span>{{ vo.name }}</span></div>
           <div style="display: flex;">
               <div style="width:150px">学号：{{ vo.studentId }}</div><div style="width:200px">专业：{{ vo.majorName }}</div><div>班级：{{ vo.className }}</div>
           </div>
           <div style="display: flex;">
               <div style="width:150px">学制：{{ vo.educationSystem }}</div><div>{{ formatStatus(vo.studentFileStatus) }}</div>
           </div>
       </div>
       <div>
           <div style="cursor:pointer;" @click="showCard"><span>学籍卡</span></div>
           <!-- <div><span>切换档案</span></div> -->
       </div>
    </div>
</template>

<script>
export default {
    components: {
    },
    props: {
        vo: {}
    },
    data: function() {
        return {
            imageSrc: ''
        }
    },
    computed: {},
    watch: {},
    created: function() {
    },
    beforeDestroy: function() {
    },
    mounted: function() {
        if (this.vo.hasPhoto) {
            this.imageSrc = `${location.origin}${process.env.VUE_APP_BASE_API}/xsgl/studentBasicInfo/download?dataField=idPhoto&nameField=photoUrl&id=${this.vo.id}&httpPort=${location.port}`
        }
    },
    methods: {
        showCard() {
            const formId = this.vo ? this.vo.id : ''
            window.open('#/newBusiForm?voId=' + formId + '&moduleInfo=' + encodeURIComponent(JSON.stringify(this.moduleInfo)) + '&title=&canEdit=false&busiInfo=学籍卡&formUrl=student.basicInfo.formCard')
            //this.dialogFormVisible = true;
        },
        formatStatus(val) {
            if (val == '0') {
                return '在籍在校'
            } else if (val == '1') {
                return '在籍离校'
            } else if (val == '2') {
                return '未激活'
            } else if (val == '3') {
                return '已离校'
            } else if (val == '4') {
                return '在籍不在校'
            }
        }
    }
}
</script>

<style scoped>
.main-box {
    padding: 20px;
}
.info-box {
    padding-bottom: 20px;
    font-size: 14px;
    display: flex;
    line-height: 30px;
}
.header {
    padding:10px 20px;
    background-color: #f2f5fb;
    font-size: 14px;
    font-weight: 500;
}
</style>
